import axios from 'axios';

const httpClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
});

httpClient.interceptors.request.use(function (config) {
  if (config.method && config.method.toUpperCase() === 'GET') {
    const loading = document.getElementById('loading');
    const noLoad = document.getElementById('no-loading');

    if (loading && !noLoad) {
      loading.style.display = 'flex';
    }
  }
  const token = window.localStorage.getItem('vallourec-api-token');
  config.headers.Authorization = `Bearer ${token}`;

  return config;
});

httpClient.interceptors.response.use(
  function (response) {
    setTimeout(() => {
      const loading = document.getElementById('loading');
      const noLoad = document.getElementById('no-loading');
      if (loading && !noLoad) {
        loading.style.display = 'none';
      }
    }, 1000);
    return response;
  },
  function (error) {
    if (!!error.response && error.response.status === 401) {
      window.localStorage.removeItem('vallourec-api-token');
      window.location.href = `${process.env.REACT_APP_REDIRECT_LOGIN}`;
    } else {
      setTimeout(() => {
        const loading = document.getElementById('loading');
        const noLoad = document.getElementById('no-loading');
        if (loading && !noLoad) {
          loading.style.display = 'none';
        }
      }, 1000);

      return Promise.reject(error);
    }
  },
);

export default httpClient;
